var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('div', {
    staticClass: "font-weight-bold"
  }, [_vm._v("團購編號：" + _vm._s(_vm.detailInfo.id))]), _c('div', [_vm._v("商品名稱：" + _vm._s(_vm.detailInfo.title))]), _c('div', [_vm._v("群組名稱：" + _vm._s(_vm.detailInfo.name))]), _c('div', [_vm._v("狀態：" + _vm._s(_vm.detailInfo.status))]), _c('div', [_vm._v("開團時間： " + _vm._s(_vm.detailInfo.start_at))]), _c('div', [_vm._v("結單時間： " + _vm._s(_vm.detailInfo.end_at))])]), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_vm.isGroupBuyEnd ? [_c('div', [_vm._v("出貨時間： 2021-01-01 14:30")]), _c('div', [_vm._v("到貨時間： 2021-01-01")]), _c('div', [_vm._v("出貨組數：50")])] : [_c('div', [_vm._v("已下單組數：55")]), _c('div', [_vm._v("未結團組數：5")])], _c('div', [_vm._v("累積總金額：2000")]), _c('div', [_vm._v("實際總金額：1780")])], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }